<template>
    <div>
        <ProjTab :current_tab="'Messenger'" :project_info="proj_data" />

        <div class="case-spisi">
            <div class="spisi-left">
                <section class="section avenue-messenger">
                    <!-- <div class="agent-face">
                <div class="half">
                    <img class="agent circle" src="http://askavenue.com/img/17.jpg" alt="Jesse Tino">
                </div>
            </div> -->
                    <div class="chat">
                        <!-- <div class="chat-title">
                            <h1>Direktna komunikacija članova projekta</h1>
                        </div> -->
                        <div class="messages" id="mylist" v-if="has_loaded_person">
                            <div class="loading-spinner"></div>
                            <div class="messages-content">
                                <div v-if="all_messages.length == 0" class="no-messages">
                                    {{ $t("messenger.start_convo") }}
                                </div>
                                <div v-else v-for="(message, key) in all_messages" :key="key">

                                    <div class="message" :class="isMyMessage(message.sender)">
                                        <div class="message-sender">
                                            {{ message.odvjetnik.ime }} {{ message.odvjetnik.prezime }}
                                        </div>
                                        <figure class="avatar"><img :src="returnAvatar(message.sender)" /></figure> {{
                                                message.message
                                        }}
                                        <div class="timestamp">{{ getRegulatedTime(message.timestamp) }} &check;</div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!--<div class="bg"></div>-->
                </section>
                <div class="message-box-wrapper">
                    <div class="message-box">
                        <input type="text" class="message-input" :placeholder="$t('messenger.placeholder')" v-model="new_msg"
                            @keyup.enter="send_message()" />

                        <button type="submit" class="message-submit" @click="send_message()">{{ $t("messenger.send") }}</button>
                    </div>
                </div>
            </div>
            <div class="spisi-right">
                <div class="detalji-spisa section detalji-radni-popratna active-members">
                    <div class="section-title">{{ $t("messenger.active_members") }}</div>
                    <div class="detalji-radni-upute-wrapper">
                        <div class="inside-folder-uputa">
                            <div class="planer-task task-done section smaller-section"
                                v-for="(user, key) in participants" :key="key">
                                <div :class="['task-checkbox', 'popup-check', isActiveUser(user.odvjetnik.uid)?'active':'']" >
                                </div>
                                <div class="planer-task-txt messenger-user">{{ user.odvjetnik.ime }}
                                    {{ user.odvjetnik.prezime }}</div>
                            </div>
                            <!-- <div class="planer-task task-done section smaller-section">
                                <div :class="['task-checkbox', 'popup-check']" >
                                </div>
                                <div class="planer-task-txt messenger-user">Jane Doe</div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import draggable from "vuedraggable";
import auth from "@/services/auth";
import projCaller from "@/apiCallers/promise_handler_db/projects"
import person from "@/apiCallers/promise_handler_db/person"
import gsap from "gsap";
import ProjTab from "@/components/projectComponents/ProjTab.vue"
import moment from "moment"
import { getProjData } from "@/router/project/handler"
import $ from "jquery"
export default {
    components: {
        draggable,
        ProjTab
    },
    data() {
        return {
            accessToken: "",
            active_users: [],
            participants: [],
            participants_uid: [],
            new_msg: "",
            proj_data: { broj_projekta: "" },
            has_loaded_person: false,
            all_messages: [],
            sioVar: {
                type: {},
                required: false,
                default: null,
            },
            my_message_class: "message-personal",
            $messages: null
        };
    },
    watch: {
        sioVar: function () {
            if (this.sioVar != null) {
                this.sioVar.socket.on("project-message", async (added_msg) => {
                    this.all_messages.push(added_msg)
                    this.new_msg = "";
                });
            }
        },
        "$store.state.sioVar": function () {
            if (this.$store.state.sioVar != null) {
                this.sioVar = this.$store.state.sioVar
            }
        },
        all_messages: function () {
            setTimeout(() => $('#mylist').animate({ scrollTop: $('#mylist').prop("scrollHeight") }, 200), 300);

        }
    },
    async created() {
        this.accessToken = this.$store.state.aToken 
        gsap.to(".loading-spinner", 0, { display: "block" });
        gsap.to(".loading-spinner", 0.5, { opacity: 1 });

        if (this.$store.state.logged_in_user == undefined || this.$store.state.logged_in_user == null) {
            await person.getSelf(this.accessToken).then((resp) => {
                this.$store.state.logged_in_user = resp.data;
                this.has_loaded_person = true

                gsap.to(".loading-spinner", 0.5, { opacity: 0 });
                gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
            })
        } else {
            this.has_loaded_person = true

            gsap.to(".loading-spinner", 0.5, { opacity: 0 });
            gsap.to(".drop-document-area", 0.5, { filter: "none", opacity: 1 });
        }
        this.sioVar = this.$store.state.sioVar
        await getProjData(this.$route.params.uid).then(async (response) => {
            this.proj_data = response;
            this.participants = response.connect_project_odvjetnik;
            this.participants_uid = this.participants.map((p) => p.odvjetnik.uid)

        })
        projCaller.get_project_messages(this.$route.params.uid).then((resp) => {
            this.all_messages = resp.data.all_messages
            this.active_users = resp.data.active_users
        })



        // console.log(this.accessToken)
    },
    computed: {
        isMyMessage() {
            return sender => {
                if (sender == this.$store.state.logged_in_user.uid) {
                    return "message-personal";
                }
                else {
                    return "message-away";
                }
            }
        }
    },

    methods: {
        isActiveUser(user_id) {
            return this.active_users.includes(user_id + "");
        },
        getRegulatedTime(timestamp) {
            if (moment(timestamp).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD"))
                return moment(timestamp).format("HH:mm")
            else {
                return moment(timestamp).format("DD.MM. HH:mm");
            }

        },

        returnAvatar(sender) {
            return process.env.VUE_APP_API_ENDPOINT_STARTER + "/" + sender + ".jpeg";
        },
        send_message: async function () {
            if (this.new_msg != "") {
                const new_msg = {
                    message: this.new_msg,
                    sender: this.$store.state.logged_in_user.uid,
                    proj_id: this.$route.params.uid
                }

                await projCaller.send_project_message(this.$route.params.uid, new_msg, this.participants_uid)
            }

        }
    },
    mounted() {
        $('.button').click(function () {
            $('.menu .items span').toggleClass('active');
            $('.menu .button').toggleClass('active');
        });
    },
    destroyed() {
        $('.button').off();
    },
};
</script>

<style>
</style>